import { Box, Button, Container, TextField } from "@mui/material"
import { useHistory } from "react-router-dom";
import { List } from './list/Index'
import { useContext, useEffect } from "react";
import { ToolContext } from '../../../core/context/ToolContext'
import { rqx } from "../../../core/request/API";
import { env } from "../../../core/Env";
import moment from "moment";

export const Payment = ({match}) => {
    const { payment_state, tool_state } = useContext(ToolContext)
    const { parameter, record } = payment_state
    const history = useHistory()
    const urlparams = new URLSearchParams(window.location.search) 
    const subdir  = match.params.type

    const handlerSubdir = (type) => {
        history.push(`/payment/${type}?tab=for-payment`)
        // parameter.set({from: '', to: ''})
        record.set({...record.data, list : [], loader : false})
    }

    const handlerTab = (tab) => {
        history.push(`/payment/${subdir}?tab=${tab}`)
        // parameter.set({from: '', to: ''})
        record.set({...record.data, list : [], loader : false})
    }

    const changeDate = (e) => {
        const { name, value } = e.target;
        parameter.set({...parameter.data, [name] : value})
    }
   
    useEffect(() => {
        const _read = async() => {
            record.set({...record.data, list : [], loader : true})
            let params = { 
                company_id: tool_state.__SESSION.data.uaccess[0].company_id, 
                type: subdir, 
                tab: urlparams.get('tab'), 
                from: parameter.data.from ? `${parameter.data.from} 00:00:01` : '',  
                to: parameter.data.to ? `${parameter.data.to} 23:59:59` : ''
            }
            const res = await rqx.get(`<<tool>>/${env()}/payment/read`, params)
            const totalAmount = res.reduce((val, item) => {
                return {
                    total_sales: urlparams.get('tab') === 'for-payment' ? val.total_sales + parseFloat(item.amount) : 0,
                    total_fees: urlparams.get('tab') === 'for-payment' ? val.total_fees + parseFloat(item.payment_fee) : 0,
                    total_paid_amount: val.total_paid_amount + parseFloat(item.total_paid_amount),
                }
            }, {total_sales: 0, total_fees: 0, total_paid_amount: 0})
            
            record.set({...record.data, list : res, loader : false, total_sales: totalAmount.total_sales, total_fees: totalAmount.total_fees, total_net_amount: urlparams.get('tab') === 'for-payment' ? (totalAmount.total_sales - totalAmount.total_fees) : totalAmount.total_paid_amount })
        }

        _read()
    
        // eslint-disable-next-line
    }, [parameter.data.from, parameter.data.to, subdir, urlparams.get('tab')])
    
    return (
        <Container maxWidth="xl" sx={{height: '100%', width: '100%'}}>
            <Box height="100%" width="100%" display="flex" flexDirection="column" gap="16px" py="32px">
                <Box component="b" fontSize={24}>Payment</Box>
                <Box display="flex" alignItems="center" gap="16px">
                    <Box component={Button} variant="contained" width="100px" onClick={() => handlerSubdir('booking')}
                        bgcolor={ subdir ==='booking' ? '#009F4D' : '#fff'} 
                        color={ subdir ==='booking' ? '#fff' : '#000'} 
                        sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff'  }}}
                    >
                        Booking
                    </Box>
                    <Box component={Button} variant="contained" width="100px" onClick={() => handlerSubdir('product')}
                        bgcolor={ subdir ==='product' ? '#009F4D' : '#fff'} 
                        color={ subdir ==='product' ? '#fff' : '#000'} 
                        sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff'  }}}
                    >
                        Product
                    </Box>
                    <Box component={Button} variant="contained" width="100px" onClick={() => handlerSubdir('training')}
                        bgcolor={ subdir ==='training' ? '#009F4D' : '#fff'} 
                        color={ subdir ==='training' ? '#fff' : '#000'} 
                        sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff'  }}}
                    >
                        Training
                    </Box>
                </Box>
                <Box display="flex" flexDirection="column" gap="24px" py="32px">
                    <Box display="flex" alignItems="center" gap="16px">
                        <Box component={Button} variant="outlined" width="130px" onClick={() => handlerTab('for-payment')}
                            border={ urlparams.get('tab') === 'for-payment' ? '1px solid #009F4D' : '1px solid #9e9e9e'}
                            color={ urlparams.get('tab') === 'for-payment' ? '#009F4D' : '#9e9e9e'} 
                            sx={{ ':hover': { border: '1px solid #009F4D', color: '#009F4D'  }}}
                        >
                            For Payment
                        </Box>
                        <Box component={Button} variant="outlined" width="130px" onClick={() => handlerTab('paid')}
                            border={ urlparams.get('tab') === 'paid' ? '1px solid #009F4D' : '1px solid #9e9e9e'}
                            color={ urlparams.get('tab') === 'paid' ? '#009F4D' : '#9e9e9e'} 
                            sx={{ ':hover': { border: '1px solid #009F4D', color: '#009F4D'  }}}
                        >
                            Paid
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                        <Box display="flex" alignItems="center" gap="32px">
                            <Box display="flex" alignItems="center" gap="8px">
                                <Box>From:</Box>
                                <TextField type="date" size="small" name="from" onChange={(e) => changeDate(e)} value={moment(parameter.data.from).format('YYYY-MM-DD')} 
                                    InputProps={{
                                        inputProps: {
                                            max: moment(parameter.data.to).format('YYYY-MM-DD')
                                        }
                                    }}
                                />
                            </Box>
                            <Box display="flex" alignItems="center" gap="8px">
                                <Box>To:</Box>
                                <TextField type="date" size="small" name="to" onChange={(e) => changeDate(e)} value={moment(parameter.data.to).format('YYYY-MM-DD')} 
                                    InputProps={{
                                        inputProps: {
                                            min: moment(parameter.data.from).format('YYYY-MM-DD') 
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                        {/* <Box>
                            <TextField size="small" name="search" />
                        </Box> */}
                    </Box>
                </Box>
                <List urlparams={urlparams} payment_state={payment_state} subdir={subdir} tool_state={tool_state} />
            </Box>
        </Container>
    )
}
